import React from 'react';
import { ArrowRight } from 'lucide-react';
const services = [{
  label: 'Ducted Reverse Cycle Installation',
  href: '/ducted-air-conditioning/'
}, {
  label: 'Split System Installation',
  href: '/split-systems-perth/'
}, {
  label: 'Reverse Cycle Air Conditioning',
  href: '/reverse-cycle-air-conditioning-perth/'
}, {
  label: 'Multi Head Splits',
  href: '/split-systems-perth/'
}, {
  label: 'Commercial Air Conditioning',
  href: '/commercial-air-conditioning-installation-in-perth/'
}, {
  label: 'Aircon Removal',
  href: '/air-conditioner-removals/'
}, {
  label: 'Smart Zone Control',
  href: '/smart-zone/'
}];
const brands = [{
  label: 'Mitsubishi Electric',
  href: '/brand/mitsubishi-air-conditioner-perth/'
}, {
  label: 'Daikin',
  href: '/brand/daikin-air-conditioning-perth/'
}, {
  label: 'Rinnai HRV',
  href: '/brand/rinnai-air-conditioning-perth/'
}, {
  label: 'Fujitsu',
  href: '/brand/'
}];
const suburbs = [{
  label: 'Air Conditioning Joondalup',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Wanneroo',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Stirling',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Karrinyup',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Subiaco',
  href: '#suburbs'
}, {
  label: 'Air Conditioning Mount Lawley',
  href: '#suburbs'
}, {
  label: 'View all Perth suburbs',
  href: '#suburbs'
}];
export function TopicalAuthority() {
  return <section className="bg-paper py-20 md:py-24" data-id="element-757">
      <div className="max-w-6xl mx-auto px-6" data-id="element-758">
        <div className="kicker mb-3" data-id="element-759">Explore Langler Air</div>
        <h2 className="text-2xl md:text-3xl font-bold text-ink-900 tracking-tight mb-10" data-id="element-760">
          Services, brands and Perth suburbs we cover.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-761">
          <div data-id="element-762">
            <h3 className="text-xs font-bold uppercase tracking-widest text-brand mb-4" data-id="element-763">
              Services
            </h3>
            <ul className="space-y-2.5" data-id="element-764">
              {services.map(s => <li key={s.label} data-id="element-765">
                  <a href={s.href} className="text-sm text-ink-900 hover:text-brand inline-flex items-center gap-1.5 group" data-id="element-766">
                    <ArrowRight size={11} className="text-stone-400 group-hover:text-brand group-hover:translate-x-0.5 transition-all" data-id="element-767" />
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-768">
            <h3 className="text-xs font-bold uppercase tracking-widest text-brand mb-4" data-id="element-769">
              Brands we install
            </h3>
            <ul className="space-y-2.5" data-id="element-770">
              {brands.map(b => <li key={b.label} data-id="element-771">
                  <a href={b.href} className="text-sm text-ink-900 hover:text-brand inline-flex items-center gap-1.5 group" data-id="element-772">
                    <ArrowRight size={11} className="text-stone-400 group-hover:text-brand group-hover:translate-x-0.5 transition-all" data-id="element-773" />
                    {b.label}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-774">
            <h3 className="text-xs font-bold uppercase tracking-widest text-brand mb-4" data-id="element-775">
              Perth area guides
            </h3>
            <ul className="space-y-2.5" data-id="element-776">
              {suburbs.map(s => <li key={s.label} data-id="element-777">
                  <a href={s.href} className="text-sm text-ink-900 hover:text-brand inline-flex items-center gap-1.5 group" data-id="element-778">
                    <ArrowRight size={11} className="text-stone-400 group-hover:text-brand group-hover:translate-x-0.5 transition-all" data-id="element-779" />
                    {s.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}